import api from "../../utils/API";

const getAllStep = () => {
  return api.get(`/AllStep/list`);
};

export {getAllStep};